// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"892d7b98","703":"03ee6759","787":"42e803fe"}[chunkId] + ".chunk.js";
};